<template>
  <div :id="appId">
    <nav id="nav" class="nav nav-pills nav-fill mb-5" v-if="isDevelopment">
      <li class="nav-link" :class="{'active': page === 'startseite'}" @click="$store.commit('setPage', 'startseite')">
        Startseite
      </li>
      <li class="nav-link" :class="{'active': page === 'otp'}" @click="$store.commit('setPage', 'otp')">
        OTP
      </li>
      <li class="nav-link" :class="{'active': page === 'callcenter'}" @click="$store.commit('setPage', 'callcenter')">
        Callcenter
      </li>
      <li class="nav-link" :class="{'active': page === 'terminbestaetigung'}" @click="$store.commit('setPage', 'terminbestaetigung')">
        Terminbestätigung
      </li>
      <li class="nav-link" :class="{'active': page === 'termin-bestaetigt'}" @click="$store.commit('setPage', 'termin-bestaetigt')">
        Terminbestätigt
      </li>
      <li class="nav-link" :class="{'active': page === 'termin-verschieben'}" @click="$store.commit('setPage', 'termin-verschieben')">
        Termin verschieben
      </li>
      <li class="nav-link" :class="{'active': page === 'termin-vorverschieben'}" @click="$store.commit('setPage', 'termin-vorverschieben')">
        Termin vor-verschieben
      </li>
      <li class="nav-link" :class="{'active': page === 'rueckruf'}" @click="$store.commit('setPage', 'rueckruf')">
        Rückruf
      </li>
    </nav>
    <startseite v-if="page === 'startseite'" />
    <otp v-else-if="page === 'otp'" />
    <callcenter v-else-if="page === 'callcenter'" />
    <callcenter-terminbestaetigung v-else-if="page === 'callcenter-terminbestaetigung'" />
    <notfall v-else-if="page === 'notfall'" />
    <terminbestaetigung v-else-if="page === 'terminbestaetigung'" />
    <termin-bestaetigt v-else-if="page === 'termin-bestaetigt'" />
    <termin-verschieben v-else-if="page === 'termin-verschieben'" />
    <termin-vor-verschieben v-else-if="page === 'termin-vorverschieben'" />
    <termin-abgesagt v-else-if="page === 'termin-cancel'" />
    <rueckruf-bitte v-else-if="page === 'rueckruf'" />
    <bp-vereinbaren v-else-if="page === 'bp-vereinbaren'" />
    <error v-else-if="page === 'error'" />
  </div>
</template>

<script>
  import Startseite from "./views/Startseite";
  import Otp from "./views/OTP";
  import Callcenter from "./views/Callcenter";
  import CallcenterTerminbestaetigung from "./views/CallcenterTerminbestaetigung";
  import Notfall from "./views/Notfall";
  import Terminbestaetigung from "./views/Terminbestaetigung";
  import TerminBestaetigt from "./views/Terminbestaetigt";
  import TerminVerschieben from "./views/Verschiebung";
  import TerminVorVerschieben from "./views/VorVerschiebung";
  import TerminAbgesagt from "./views/TerminAbgesagt";
  import BpVereinbaren from "./views/BP";
  import Error from "./views/Error";
  import { DateTime } from "luxon";
  import RueckrufBitte from "./views/RueckrufBitte.vue";
  import { SET_HASHED_ID, SET_CALLCENTER } from './store/mutations.type';

  export default {
    name: "OnlineTerminBuchung",
    components: {
      Startseite,
      Otp,
      Callcenter,
      CallcenterTerminbestaetigung,
      Notfall,
      Terminbestaetigung,
      TerminBestaetigt,
      TerminVerschieben,
      TerminVorVerschieben,
      TerminAbgesagt,
      BpVereinbaren,
      RueckrufBitte,
      Error,
    },
    async created() {
      if (this.$route.query.lang) {
        this.$i18n.locale = this.$route.query.lang;
      }

      if (this.$route.query.lng) {
        this.$i18n.locale = this.$route.query.lng;
      }

      if(this.$route.query.p) {
        let patient_id_hash = this.$route.query.p
        this.$store.commit(`patient/${SET_HASHED_ID}`, patient_id_hash)
      }

      if (this.$route.query.b) {
        let setTerminart = true;

        if (this.$route.query.x) {
          let expires = parseInt(this.$route.query.x);

          if (DateTime.local().ts > expires) setTerminart = false;
        }

        if (setTerminart) {
          navigator.bx_terminart = this.$route.query.b;
          navigator.bx_startseite = "otp";
        }
      }

      if (this.$route.query.token) {
        this.$store.commit("setPage", "termin-bestaetigt");
      } else if (this.$route.query.move) {
        this.$store.commit("setPage", "termin-verschieben");
      } else if (this.$route.query.moveearly) {
        this.$store.commit("setPage", "termin-vorverschieben");
      } else if (this.$route.query.bp) {
        this.$store.commit("setPage", "bp-vereinbaren");
      } else if (this.$route.query.cancel) {
        this.$store.commit("setPage", "termin-cancel");
      } else if (this.$route.query.recall) {
        this.$store.commit("setPage", "rueckruf");
      } else if (this.$route.query.callcenter=="b74a2ed4-fdd9-4247-9c98-976ac8bec193") {
        this.$store.commit("setPage", "callcenter");
        this.$store.commit(SET_CALLCENTER, true);
      } else {
        // Festlegung der Startseite je nach navigator-Variable
        if (
          navigator.bx_startseite &&
          (navigator.bx_startseite == "otp" ||
            navigator.bx_startseite == "startseite")
        ) {
          this.$store.commit("setPage", navigator.bx_startseite);
        } else {
          this.$store.commit("setPage", "otp");
        }
      }
    },
    computed: {
      page() {
        return this.$store.state.page;
      },
    },
  };
</script>

<style lang="scss">
  //@import "./scss/hager.scss";
</style>
